import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=7a3a1c0a&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=7a3a1c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a1c0a",
  null
  
)

/* custom blocks */
import block0 from "./Transaction.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports